export const jurisdictionOptions = [
  'Colorado',
  'Connecticut',
  'Mississippi',
  'Nebraska',
  'New Jersey',
  'New York',
  'Rhode Island',
  'Washington',
  'Wisconsin',
];

export const reportTypeOptions = ['Stolen', 'Missing', 'Lost', 'Found Pack'];

export const packTypeOptions = [
  'Entire Pack(s)',
  'Partial Pack(s)',
  'Both Partial and Entire Packs',
];
